// Display helpers.

/** Formats an RFC 3339 time for display, in UTC. Returns "never" for null. */
export function formatTime(value: string | null | undefined, none = "never"): string {
  if (!value) return none;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d
    .toISOString()
    .replace("T", " ")
    .replace(/\.\d+Z$/, "Z")
    .replace(/Z$/, " UTC");
}

/** Formats a byte count, for example 1536 -> "1.5 KiB". */
export function formatBytes(n: number): string {
  const units = ["B", "KiB", "MiB", "GiB", "TiB"];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return i === 0 ? `${v} B` : `${v.toFixed(1)} ${units[i]}`;
}

/** Slug rule for tenants and namespaces (docs/api.md section 1). */
export const SLUG_RE = /^[a-z][a-z0-9-]{1,38}[a-z0-9]$/;

/** Reserved tenant slugs (docs/api.md section 1). */
export const RESERVED_TENANT_SLUGS = [
  "api",
  "admin",
  "app",
  "www",
  "sts",
  "cargo",
  "oci",
  "prego",
  "k8skill",
  "katskill",
  "static",
  "docs",
];

/** Returns an error message for a bad slug, or null if the slug is valid. */
export function slugError(slug: string, tenant: boolean): string | null {
  if (!SLUG_RE.test(slug)) {
    return "Use 3 to 40 characters: lowercase letters, digits and '-'. Start with a letter. Do not end with '-'.";
  }
  if (tenant && RESERVED_TENANT_SLUGS.includes(slug)) return `The slug "${slug}" is reserved.`;
  return null;
}

/** Package glob rule (docs/api.md 2.4): crate name chars, optional `*` at the end only. */
export const PACKAGE_GLOB_RE = /^(\*|[A-Za-z][A-Za-z0-9_-]{0,63}\*?)$/;
